// react
import styled, { css } from 'styled-components';

// components
import { Button } from '@/components/atoms';

// icons
import { Icons } from '@/components/atoms/Icon';

/**
 * FloatingActions shows floating actions at the bottom of the screen.
 */
export const FloatingActions = ({
  className,
  actions,
  isSticky,
  direction = 'row',
}: FloatingActionsProps) => {
  return (
    <ActionButtons
      className={className}
      $isSticky={isSticky}
      $direction={direction}
    >
      {actions?.map((action) => (
        <Button
          key={action.label}
          ariaLabel={action.label}
          variant={action.variant}
          onPress={action.onPress}
          iconLeft={action.iconLeft}
          iconRight={action.iconRight}
          to={action.to}
          isDisabled={action.isDisabled}
        >
          {action.label}
        </Button>
      ))}
    </ActionButtons>
  );
};

const ActionButtons = styled.div<{ $isSticky?: boolean; $direction: string }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: ${(props) => props.theme.spacing[16]};
  border-top: 1px solid ${(props) => props.theme.color.neutral[50]};
  background: ${(props) => props.theme.color.neutral[10]};
  z-index: 1;

  & button,
  & a {
    min-width: 120px;
  }
  ${(props) =>
    props.$isSticky &&
    css`
      position: sticky;
    `}

  ${(props) =>
    props.$direction == 'col'
      ? css`
          flex-direction: column;
          padding: ${(props) => props.theme.spacing[16]};
        `
      : css`
          padding: ${(props) => props.theme.spacing[16]} 0;
        `}
`;

export interface Action {
  label: string;
  variant?: 'primary' | 'secondary';
  onPress?: () => void;
  iconLeft?: Icons;
  iconRight?: Icons;
  to?: string;
  isDisabled?: boolean;
}
interface FloatingActionsProps {
  className?: string;
  actions: Action[];
  isSticky?: boolean;
  direction?: 'row' | 'col';
}

FloatingActions.displayName = 'FloatingActions';

export default FloatingActions;
